import { z } from "zod";

export const dimensionsSchema = z.object({
	length: z.number(),
	width: z.number(),
	height: z.number(),
});

export const mediaSchema = z.object({
	style: z.string().nullish(),
	dimensions: dimensionsSchema,
	thickness: z.number().nullish(),
	brand: z.string().nullish(),
	attributes: z.record(z.string(), z.string()),
});

export const packagingComponentBaseSchema = z.object({
	id: z.string().optional(),
	media: mediaSchema,
	attributes: z.record(z.string(), z.string()),
});

export type PackagingComponentBase = z.infer<typeof packagingComponentBaseSchema>;
export type Media = z.infer<typeof mediaSchema>;
export type Dimensions = z.infer<typeof dimensionsSchema>;
